module.exports = __webpack_public_path__ + "static/img/animales_17.b4fa639a.jpg";